<template>
  <el-dialog
    :visible.sync="show"
    :before-close="close"
    :close-on-click-modal="false"
    @open="openDialog"
    width="70%"
    top="7vh"
    >
    <div slot="title" class="dia-tit">
      <i></i>
      <span>成员管理</span>
    </div>
    <el-row :gutter="50">
      <el-col :span="12">
        <el-row>员工列表</el-row>
        <el-row>
          <el-input
            placeholder="输入搜索用户名、姓名关键字"
            v-model="inputVal"
            style="width: 380px;margin:10px 10px 10px 0"
            @keyup.enter.native="search"
          >
            <el-select v-model="select" slot="prepend" placeholder="请选择" style="width: 120px;">
              <el-option label="用户名" value="1"></el-option>
              <el-option label="姓名" value="2"></el-option>
            </el-select>
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <el-button @click="search" type="primary" class="tb-button" size="small">搜索</el-button>
          <el-button @click="reset" type="primary" class="tb-button" size="small">重置</el-button>
        </el-row>

        <el-row :gutter="12" class="mb-10">
          <el-col :span="12">
            <el-cascader
              v-model="dtDpid"
              :options="departmentList"
              class="w100"
              clearable
              placeholder="请选择部门"
              :props="cascaderProps">
            </el-cascader>
          </el-col>
          <el-col :span="12">
            <el-select
                v-model="dtPosition"
                class="w100"
                placeholder="请选择角色"
                clearable
                filterable
              >
                <el-option
                  v-for="item in positionArray"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
          </el-col>
        </el-row>
        <el-table
          :data="staffList"
          @selection-change="handleStaffChange"
          border
          fit
          highlight-current-row
        >
          <el-table-column type="selection" align="center"></el-table-column>
          <el-table-column label="用户名" align="center">
            <template slot-scope="scope">{{ scope.row.loginName }}</template>
          </el-table-column>
          <el-table-column label="姓名" align="center">
            <template slot-scope="scope">{{ scope.row.name }}</template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button size="mini" plain type="primary" @click="add(scope.row, scope.$index)">添 加</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button @click="batchAdd" type="info" size="small" style="margin-top:20px;">批量添加</el-button>
        <el-pagination
          @current-change="handleStaffCurrentChange"
          :current-page="staffPagination.currentPage"
          :page-size="staffPagination.pageSize"
          layout="prev, pager, next, jumper"
          :total="staffPagination.total">
        </el-pagination>
      </el-col>
      <!-- 已选成员 -->
      <el-col :span="12">
        <el-row>已有成员</el-row>
        <el-row>
          <el-input
            placeholder="输入搜索用户名、姓名关键字"
            v-model="inputValTwo"
            style="width: 380px;margin:10px 10px 10px 0"
            @keyup.enter.native="searchTwo"
          >
            <el-select v-model="selectTwo" slot="prepend" placeholder="请选择" style="width: 120px;">
              <el-option label="用户名" value="1"></el-option>
              <el-option label="姓名" value="2"></el-option>
            </el-select>
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <el-button @click="searchTwo" type="primary" class="tb-button" size="small">搜索</el-button>
          <el-button @click="resetTwo" type="primary" class="tb-button" size="small">重置</el-button>
        </el-row>
        <el-table
          :data="tableData"
          @selection-change="handleSelectionChange"
          border
          fit
          highlight-current-row
        >
          <el-table-column type="selection" align="center"></el-table-column>
          <el-table-column label="用户名" align="center">
            <template slot-scope="scope">{{ scope.row.loginName }}</template>
          </el-table-column>
          <el-table-column label="姓名" align="center">
            <template slot-scope="scope">{{ scope.row.name }}</template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button size="mini" plain type="danger" @click="del(scope.row, scope.$index)">删 除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button @click="batchDel" type="info" size="small" style="margin-top:20px;">批量删除</el-button>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { getListEmployee, getchildDp, getPositionList } from '@/api/system/staff'
import { getUserByRole, addUserRole, delUserRole } from '@/api/system/role'

export default {
  props: {
    show: {
      default: false,
      type: Boolean
    },
    roleId: {
      default: '',
      type: String
    }
  },
  data () {
    return {
      staffList: [],
      tableData: [],
      seleData: [],
      seleStaffData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      staffPagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      select: '2',
      inputVal: '',
      inputValTwo: '',
      selectTwo: '2',
      positionArray: [],
      departmentList: [],
      dtDpid: '',
      dtPosition: '',
      cascaderProps: {
        lazy: true,
        value:"id",
        label:"name",
        checkStrictly: true,
        lazyLoad(node, resolve) {
          // 如果是顶级的父节点
          if (node.level === 0) {
            getchildDp({}).then(res => {
              if (res.state === 'success') {
                let nodeData = res.body
                nodeData.push({
                  id: "-1",
                  name: "未分配"
                })
                return resolve(nodeData)
              }
            })
          } else {
            getchildDp({
              dpid: node.value
            }).then(res => {
              if (res.state === 'success') {
                let nodeData = res.body
                return resolve(nodeData)
              }
            })
          }
        },
      }
    }
  },
  methods: {
    openDialog () {
      this.sele = ''
      this.inputVal = ''
      this.dtDpid = ''
      this.dtPosition = ''
      // 获取员工列表
      this.getPositionList()
      // this.getDeptManagerList()
      this.listEmployee()
      // 获取当前角色列表
      this.getUserByRole()
    },
    async listEmployee () {
      const res = await getListEmployee({
        pageNum: this.staffPagination.currentPage,
        pageSize: this.staffPagination.pageSize,
        loginName: this.select === '1' ? this.inputVal : '',
        name: this.select === '2' ? this.inputVal : '',
        dtDpid: this.dtDpid ? this.dtDpid[this.dtDpid.length-1] : null,
        dtPosition: this.dtPosition ? this.dtPosition : null,
        state: 1
      })
      this.staffList = res.body.list
      this.staffPagination.total = res.body.total
    },

    // 关闭
    close () {
      this.$emit('close')
    },

    async getPositionList() {
      const res = await getPositionList()
      this.positionArray = res.body
    },

    getDeptManagerList (dpid) {
      getchildDp({
        dpid: dpid ? dpid : ''
      }).then(res => {
        if (res.state === 'success') {
          if (!dpid) {
            let data = res.body
            // data.push({
            //   id: '-1',
            //   name: '未分配'
            // })
            this.departmentList = data
          }
        }
      })
    },

    // 根据角色获取用户列表
    async getUserByRole () {
      const res = await getUserByRole({
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        needCount: true,
        roleId: this.roleId,
        loginName: this.selectTwo === '1' ? this.inputValTwo : '',
        name: this.selectTwo === '2' ? this.inputValTwo : ''
      })
      this.tableData = res.body.list
      this.pagination.total = res.body.total
    },

    // 添加角色用户
    add (row) {
      addUserRole({
        roleId: this.roleId,
        userIds: [row.userId]
      }).then(res => {
        if (res.state === 'success') {
          window.$msg('添加成功')
          this.getUserByRole()
        } else {
          if (res.errMsg === '用户已存在角色') {
            window.$msg('用户已添加', 2)
          } else {
            window.$msg(res.errMsg, 2)
          }
        }
      })
    },

    // 搜索、重置
    search () {
      this.staffPagination.currentPage = 1
      this.listEmployee()
    },
    reset () {
      this.select = '2'
      this.inputVal = ''
      this.dtDpid = ''
      this.dtPosition = ''
    },

    searchTwo () {
      this.pagination.currentPage = 1
      this.getUserByRole()
    },

    resetTwo () {
      this.selectTwo = '2'
      this.inputValTwo = ''
    },

    // 批量添加角色用户
    batchAdd () {
      if (this.seleStaffData.length !== 0) {
        let addArray = []
        this.seleStaffData.forEach((item) => {
          addArray.push(item.userId)
        })
        addUserRole({
          roleId: this.roleId,
          userIds: addArray
        }).then(res => {
          if (res.state === 'success') {
            window.$msg('添加成功')
            this.getUserByRole()
          } else {
            if (res.errMsg === '用户已存在角色') {
              window.$msg('用户已添加', 2)
            } else {
              window.$msg(res.errMsg, 2)
            }
          }
        })
      } else {
        window.$msg('无勾选数据', 2)
      }
    },

    // 分页
    handleCurrentChange (val) {
      this.pagination.currentPage = val
      this.getUserByRole()
    },
    handleStaffCurrentChange (val) {
      this.staffPagination.currentPage = val
      this.listEmployee()
    },
    handleSelectionChange (sele) {
      this.seleData = sele
    },
    handleStaffChange (sele) {
      this.seleStaffData = sele
    },
    del (row, index) {
      this.$confirm('是否删除当前成员？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delUserRole({
            roleId: this.roleId,
            userIds: [row.id]
          }).then(res => {
            if (res.state === 'success') {
              window.$msg('删除成功')
              this.getUserByRole()
            }
          })
        })
        .catch(() => {
          return false
        })
    },
    // 批量删除
    batchDel () {
      if (this.seleData.length !== 0) {
        this.$confirm('是否批量删除当前成员？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let delArr = []
            this.seleData.forEach((item) => {
              delArr.push(item.id)
            })
            delUserRole({
              roleId: this.roleId,
              userIds: delArr
            }).then(res => {
              if (res.state === 'success') {
                window.$msg('删除成功')
                this.getUserByRole()
              }
            })
          })
          .catch(() => {
            return false
          })
      } else {
        window.$msg('无勾选数据', 2)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../style/dialog.scss';
/deep/ .el-table td {
  padding: 10px 0 !important;
}
</style>
